export const SET_MENU_ITEMS = 'setMenuItems';



// WEBPACK FOOTER //
// ./src/store/nav/nav.mutations.js